import React, { useEffect, useState } from "react";
import { searchDashboardService } from "../../../../services/searchDashboard";
import { abbrNum } from "../../../../utils/abbreviateNumber";
import { HeadCardInfo } from "./HeadCardInfo";
import { HeadCardMissingDates } from "./HeadCardMissingDates";
import styles from "./HeadInfo.module.css";
// import { TqOverviewCard } from "./TqOverviewCard";

export const HeadInfo = ({
  missingDates,
  missingDatesLoading,
  searchPermissions,
}) => {
  const [loading, setLoading] = useState(false);
  const [cardData, setCardData] = useState([]);
  const [dataInfo, setDataInfo] = useState([]);
  const [cardDataN2S, setCardDataN2S] = useState([]);
  const [dataInfoN2S, setDataInfoN2S] = useState([]);

  useEffect(() => {
    const fetchCardInfo = async () => {
      setLoading(true);
      try {
        const [dataChart, data, dataChartN2S, dataN2S] = await Promise.all([
          searchDashboardService.getTopCardInfoChart(
            searchPermissions.extension
          ),
          searchDashboardService.getTopCardInfo(searchPermissions.extension),
          searchDashboardService.getTopCardInfoChartN2s(searchPermissions.n2s),
          searchDashboardService.getTopCardInfoN2s(searchPermissions.n2s),
        ]);
        setCardData(dataChart.values);
        setDataInfo(data);
        setCardDataN2S(dataChartN2S.values);
        setDataInfoN2S(dataN2S);
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };
    fetchCardInfo();
  }, [searchPermissions]);
  return (
    <div className={styles.headInfoContainer}>
      {searchPermissions.extension && (
        <>
          <HeadCardInfo
            chartData={cardData}
            module="extension"
            dataInfo={
              dataInfo.total && abbrNum(dataInfo.total[0].monetized_searches, 2)
            }
            loading={loading}
            type="1"
            title="Monetized Searches - Search Type-In"
            color="#c2d791"
          />
          <HeadCardInfo
            chartData={cardData}
            module="extension"
            loading={loading}
            dataInfo={
              dataInfo.total && "$ " + abbrNum(dataInfo.total[0].revenue, 2)
            }
            type="2"
            title="Revenue - Search Type-In"
            color="#f7ae3d"
          />
          {/* <TqOverviewCard /> */}
        </>
      )}
      {searchPermissions.n2s && (
        <>
          <HeadCardInfo
            chartData={cardDataN2S}
            module="n2s"
            dataInfo={
              dataInfoN2S.total &&
              abbrNum(dataInfoN2S.total[0].monetized_searches, 2)
            }
            loading={loading}
            type="1"
            title="Monetized Searches - N2S"
            color="#c2d791"
          />
          <HeadCardInfo
            chartData={cardDataN2S}
            module="n2s"
            loading={loading}
            dataInfo={
              dataInfoN2S.total &&
              "$ " +
                Number(dataInfoN2S.total[0].revenue).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
            }
            type="2"
            title="Revenue - N2S"
            color="#f7ae3d"
          />
        </>
      )}
      {!(searchPermissions.extension && searchPermissions.n2s) && (
        <HeadCardMissingDates
          missingDates={missingDates}
          missingDatesLoading={missingDatesLoading}
        />
      )}
    </div>
  );
};
